
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectActivityDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ProjectActivityId: string;
  @IsNotEmpty() ProjectActivityName: string;
  @IsNotEmpty() ProjectActivityDescription: string;
  @IsNotEmpty() ProjectId: string;

}
